/** 編集モード */
export const Mode: { [key: string]: string } = {
  EDIT: "edit",
  CREATE: "create",
  PREVIEW: "preview",
};
export type Mode = typeof Mode[keyof typeof Mode];

/** プレビュー時のデバイス */
export const Device: { [key: string]: string } = {
  MOBILE: "mobile",
  PREVIEW: "tablet",
  DESKTOP: "desktop",
};
export type Device = typeof Device[keyof typeof Device];

/**
 * テンプレートタイプ
 */
export const TemplateType = {
  IMG: "img",
  MOVIE: "movie",
  HEAD: "head",
  PROFILE: "profole",
  FRAME: "frame",
  BULLET: "bullet",
  SLIDER: "slider",
  IMG_TEXT: "img_text",
  SEPARATOR: "separator",
  SUMMARY: "summary",
  TABLE: "table",
  SNS: "sns",
  VOICE: "voice",
  QA: "qa",
  FORM: "form",
  BUTTON: "button",
  FIXED_BUTTON: "fixed_button",
};
export type TemplateType = typeof TemplateType[keyof typeof TemplateType];

export interface TemplateTypeListProps {
  label: string;
  value: string;
  select?: boolean;
}

export const TemplateTypeLabel: TemplateTypeListProps[] = [
  { label: "画像", value: TemplateType.IMG },
  { label: "動画", value: TemplateType.MOVIE },
  { label: "見出し", value: TemplateType.HEAD },
  { label: "プロフィール", value: TemplateType.PROFILE },
  { label: "フレーム", value: TemplateType.FRAME },
  { label: "箇条書き", value: TemplateType.BULLET },
  { label: "スライダー", value: TemplateType.SLIDER },
  { label: "画像＋テキスト", value: TemplateType.IMG_TEXT },
  { label: "スペース＆区切り線", value: TemplateType.SEPARATOR },
  { label: "開催概要", value: TemplateType.SUMMARY },
  { label: "テーブル", value: TemplateType.TABLE },
  { label: "SNSボタン", value: TemplateType.SNS },
  { label: "体験談・お客様の声", value: TemplateType.VOICE },
  { label: "よくある質問", value: TemplateType.QA },
  { label: "フォーム", value: TemplateType.FORM },
  { label: "ボタン", value: TemplateType.BUTTON },
  { label: "画面固定ボタン", value: TemplateType.FIXED_BUTTON },
];

/**
 * テンプレート
 */
export interface TemplateProps {
  id: string;
  label: string;
  type: TemplateType;
}

/**
 * タイプ別のテンプレートリスト
 * TODO:仮データの為、仕様等確定次第修正
 */
export const BlockTemplates: TemplateProps[] = [
  // 画像 --------------------------------------
  {
    id: "img",
    label: "画像",
    type: TemplateType.IMG,
  },
  {
    id: "img-center",
    label: "中央寄せ",
    type: TemplateType.IMG,
  },
  {
    id: "img-form",
    label: "中央寄せ＋フォーム",
    type: TemplateType.IMG,
  },
  {
    id: "img-button",
    label: "中央寄せ＋ボタン",
    type: TemplateType.IMG,
  },
  {
    id: "img-slider",
    label: "スライダー",
    type: TemplateType.IMG,
  },
  // 動画 --------------------------------------
  {
    id: "movie",
    label: "動画",
    type: TemplateType.MOVIE,
  },
  // 見出し --------------------------------------
  {
    id: "head",
    label: "見出し",
    type: TemplateType.HEAD,
  },
  {
    id: "head-border",
    label: "見出し：枠付き",
    type: TemplateType.HEAD,
  },
  {
    id: "head-balloon",
    label: "見出し：吹き出し",
    type: TemplateType.HEAD,
  },
  {
    id: "head-arrow",
    label: "見出し：矢印",
    type: TemplateType.HEAD,
  },
  {
    id: "head-sandwich",
    label: "見出し：上下線",
    type: TemplateType.HEAD,
  },
  {
    id: "head-accent",
    label: "見出し：アクセント（左縦線）",
    type: TemplateType.HEAD,
  },
  {
    id: "head-number",
    label: "見出し：大見出し（数字）",
    type: TemplateType.HEAD,
  },
  {
    id: "head-marker",
    label: "見出し：マーカー",
    type: TemplateType.HEAD,
  },
  // プロフィール --------------------------------------
  {
    id: "plofile-border",
    label: "プロフィール：枠あり",
    type: TemplateType.PROFILE,
  },
  {
    id: "plofile",
    label: "プロフィール：枠なし",
    type: TemplateType.PROFILE,
  },
  // フレーム --------------------------------------
  {
    id: "frame",
    label: "フレーム（見出し＋テキスト）",
    type: TemplateType.FRAME,
  },
  {
    id: "frame-separator",
    label: "フレーム（見出し＋区切り線＋テキスト）",
    type: TemplateType.FRAME,
  },
  {
    id: "frame-img-text",
    label: "フレーム（見出し＋画像＋テキスト）",
    type: TemplateType.FRAME,
  },
  // 箇条書き --------------------------------------
  {
    id: "bullet",
    label: "リスト",
    type: TemplateType.BULLET,
  },
  {
    id: "bullet-botder",
    label: "リスト（枠付）",
    type: TemplateType.BULLET,
  },
  {
    id: "bullet-arrow",
    label: "リスト（矢印）",
    type: TemplateType.BULLET,
  },
  {
    id: "bullet-step",
    label: "ステップ",
    type: TemplateType.BULLET,
  },
  {
    id: "bullet-step-img",
    label: "ステップ（画像付き）",
    type: TemplateType.BULLET,
  },
  // スライダー --------------------------------------
  {
    id: "slider-marketing",
    label: "スライダー：マーケティング",
    type: TemplateType.SLIDER,
  },
  {
    id: "slider-recruiting",
    label: "スライダー：リクルーティング",
    type: TemplateType.SLIDER,
  },
  {
    id: "slider",
    label: "スライダー",
    type: TemplateType.SLIDER,
  },
  {
    id: "slider-feedback",
    label: "スライダー：感想",
    type: TemplateType.SLIDER,
  },
  {
    id: "slider-feedback-2",
    label: "スライダー：感想２",
    type: TemplateType.SLIDER,
  },
  {
    id: "slider-introduction",
    label: "スライダー：紹介",
    type: TemplateType.SLIDER,
  },
  // 画像＋テキスト --------------------------------------
  {
    id: "img-text",
    label: "上画像2列",
    type: TemplateType.IMG_TEXT,
  },
  {
    id: "img-text-talk",
    label: "会話風",
    type: TemplateType.IMG_TEXT,
  },
  {
    id: "img-text-left",
    label: "左フル画像",
    type: TemplateType.IMG_TEXT,
  },
  // スペース＆区切り線 --------------------------------------
  {
    id: "space-30px",
    label: "スペース（30px）",
    type: TemplateType.SEPARATOR,
  },
  {
    id: "space-50px",
    label: "スペース（50px）",
    type: TemplateType.SEPARATOR,
  },
  {
    id: "space-100px",
    label: "スペース（100px）",
    type: TemplateType.SEPARATOR,
  },
  {
    id: "line-1px",
    label: "区切り線（実線1px）",
    type: TemplateType.SEPARATOR,
  },
  {
    id: "line-3px",
    label: "区切り線（実線3px）",
    type: TemplateType.SEPARATOR,
  },
  {
    id: "line-5px",
    label: "区切り線（実線5px）",
    type: TemplateType.SEPARATOR,
  },
  // 開催概要 --------------------------------------
  {
    id: "summary-table-border",
    label: "表（項目付き＋枠線付き）",
    type: TemplateType.SUMMARY,
  },
  {
    id: "summary-table",
    label: "表（項目付き＋枠線なし＋下線のみ）",
    type: TemplateType.SUMMARY,
  },
  {
    id: "summary",
    label: "1列",
    type: TemplateType.SUMMARY,
  },
  // テーブル --------------------------------------
  {
    id: "table-1",
    label: "テーブル（2ブロック/左カラム小）",
    type: TemplateType.TABLE,
  },
  {
    id: "table-2",
    label: "テーブル（2ブロック/均等）",
    type: TemplateType.TABLE,
  },
  {
    id: "table-3",
    label: "テーブル（3ブロック/均等）",
    type: TemplateType.TABLE,
  },
  {
    id: "table-4",
    label: "テーブル（4カラム/均等）",
    type: TemplateType.TABLE,
  },
  // SNSボタン --------------------------------------
  {
    id: "sns",
    label: "左画像",
    type: TemplateType.SNS,
  },
  // 体験談・お客様の声 --------------------------------------
  {
    id: "voice",
    label: "お客様の声",
    type: TemplateType.VOICE,
  },
  {
    id: "voice-gorgeous",
    label: "お客様の声（ゴージャス）",
    type: TemplateType.VOICE,
  },
  {
    id: "voice-pleasure",
    label: "喜びの声",
    type: TemplateType.VOICE,
  },
  {
    id: "voice-pickup",
    label: "ピックアップ",
    type: TemplateType.VOICE,
  },
  // よくある質問 --------------------------------------
  {
    id: "qa-1",
    label: "よくある質問１",
    type: TemplateType.QA,
  },
  {
    id: "qa-2",
    label: "よくある質問２",
    type: TemplateType.QA,
  },
  {
    id: "qa-accordion-gorgeous",
    label: "よくある質問折りたたみ（ゴージャス）",
    type: TemplateType.QA,
  },
  {
    id: "qa-accordion",
    label: "よくある質問折りたたみ",
    type: TemplateType.QA,
  },
  // フォーム --------------------------------------
  {
    id: "form-business",
    label: "フォーム（企業様向け）",
    type: TemplateType.FORM,
  },
  {
    id: "form-simple",
    label: "フォーム（シンプル）",
    type: TemplateType.FORM,
  },
  {
    id: "form",
    label: "フォーム",
    type: TemplateType.FORM,
  },
  // ボタン --------------------------------------
  {
    id: "button-",
    label: "ボタン（大/二重矢印）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-",
    label: "ボタン（大/矢印）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-",
    label: "ラウンドボタン（大）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-",
    label: "ラウンドボタン（大/矢印）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-border",
    label: "縁ありボタン",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-shadow",
    label: "影ありボタン",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-icon",
    label: "アイコンボタン（フレーム内縁あり）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-thin-frame",
    label: "ボタン（細フレーム）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-both-side",
    label: "ボタン（両サイドアイコン）",
    type: TemplateType.BUTTON,
  },
  {
    id: "button-free",
    label: "ボタン（無料表示）",
    type: TemplateType.BUTTON,
  },
  // 画面固定ボタン --------------------------------------
  {
    id: "fixed-button-bottom",
    label: "ボタン（下つき）",
    type: TemplateType.FIXED_BUTTON,
  },
  {
    id: "fixed-button-bottom-bg",
    label: "ボタン（下つき/背景あり）",
    type: TemplateType.FIXED_BUTTON,
  },
];

/**
 * Jotaiのデータ管理にて使用するstatusの値
 */
export const DataStatus: { [key: string]: string } = {
  TEMPLATES: "Templates", //テンプレートリスト
  CONTAINERS: "Containers", //編集ブロックのリスト
  PAGE_STYLE: "PageStyle", //ページ背景やフォント等、ページ全体のスタイル設定
  NO_DATA: "NoData", //データ無し(初期化後、データが空の状態)
};
export type DataStatus = typeof DataStatus[keyof typeof DataStatus];

/**
 * ベーシックなSelectのOptionの型
 */
export interface Option<T extends string | number> {
  text: string;
  value: T;
}

/**
 * 選択後と選択肢で文言が違うタイプのOption
 */
export interface LabelOption<T extends string | number> {
  text: string;
  value: T;
  label: string;
}

export const SampleText = "Aaあア亜";

export const GothicFont = [
  {
    text: `${SampleText} Noto Sans JP`,
    value: "'Noto Sans JP', sans-serif",
  },
  {
    text: `${SampleText} Zen Kaku Gothic New`,
    value: "'Zen Kaku Gothic New', sans-serif",
  },
  {
    text: `${SampleText} BIZ UDPGothic`,
    value: "'BIZ UDGothic', sans-serif",
  },
  {
    text: `${SampleText} IBM Plex Sans JP`,
    value: "'IBM Plex Sans JP', sans-serif",
  },
  {
    text: `${SampleText} M PLUS 1p`,
    value: "'M PLUS 1p', sans-serif",
  },
];

export const MinchoFont = [
  {
    text: `${SampleText} Noto Serif JP`,
    value: "'Noto Serif JP', serif",
  },
  {
    text: `${SampleText} Zen Old Mincho`,
    value: "'Zen Old Mincho', serif",
  },
  {
    text: `${SampleText} BIZ UDPMincho`,
    value: "'BIZ UDPMincho', serif",
  },
];
/**
 * フォントファミリー設定プルダウンの選択肢(見出し設定用)
 */
export const fontFamilyOptions: Option<string>[] = [
  ...GothicFont,
  ...MinchoFont,
];
/**
 * フォントサイズ設定のラベル
 */
export const FontSizeLabel = {
  L: "大",
  M: "中",
  S: "小",
  XL: "特大",
} as const;
/**
 * フォントサイズ設定のValue
 */
export const FontSizeValue = {
  L: "1.375rem",
  M: "1.125rem",
  S: "1rem",
  XL: "2rem",
} as const;
export type FontSizeKey = keyof typeof FontSizeValue;
/**
 * フォントサイズ設定プルダウンの選択肢
 */
export const fontSizeOptions: LabelOption<string>[] = [
  {
    text: `${FontSizeLabel.L}見出し`,
    value: FontSizeValue.L,
    label: FontSizeLabel.L,
  },
  {
    text: `${FontSizeLabel.M}見出し`,
    value: FontSizeValue.M,
    label: FontSizeLabel.M,
  },
  {
    text: `${FontSizeLabel.S}見出し`,
    value: FontSizeValue.S,
    label: FontSizeLabel.S,
  },
  {
    text: `${FontSizeLabel.XL}見出し`,
    value: FontSizeValue.XL,
    label: FontSizeLabel.XL,
  },
];

/**
 * テンプレートのテキスト入力欄全体に適用されるスタイル
 */
export interface TextBaseStyle {
  fontSize?: string;
  fontFamily?: string;
}

/**
 * テキストエディターのツールバーのセット(HEADINGがデフォルト)
 */
export const ToolbarSet = {
  HEADING: [
    "UNDERLINE",
    "left",
    "center",
    "right",
    "color",
    "backgroundColor",
    "insertLink",
    "fontSize",
    "fontFamily",
  ],
  TEXT: [
    "BOLD",
    "UNDERLINE",
    "color",
    "backgroundColor",
    "left",
    "center",
    "right",
    "insertLink",
    "fontFamily",
  ],
  BUTTON: ["color", "backgroundColor", "fontSize"],
};

/**
 * パーツタイプ
 */
// TODO:api確定後、それに合わせて値を変更？
export const PartsType: { [key: string]: number } = {
  HEAD: 0,
  TEXT: 1,
  IMG: 2,
  BUTTON: 3,
  MOVIE: 4,
  CHECKBOX: 5,
  SLIDER: 6,
  FORM: 7,
  TABLE: 8,
};
export type PartsType = typeof PartsType[keyof typeof PartsType];

/**
 * パーツデザインタイプ
 */
// TODO:api確定後、それに合わせて値を変更？テーブル定義の「ブロック内ボタン」から暫定的に設定
export const PartsDesign: { [key: string]: number } = {
  TYPE_1: 0,
  TYPE_2: 1,
  TYPE_3: 2,
  TYPE_4: 3,
  TYPE_5: 4,
  TYPE_6: 5,
  TYPE_7: 6,
  TYPE_8: 7,
  TYPE_9: 8,
};
export type PartsDesign = typeof PartsDesign[keyof typeof PartsDesign];

/**
 * カラーの設定 カラーパレット
 */
export const ColorPalette: string[] = [
  "#FF8B7F",
  "#FFAD65",
  "#FFE169",
  "#C1E573",
  "#73E6A3",
  "#A1D0E6",
  "#A0ABE5",
  "#D2A1E6",
  "#FFFFFF",
  "#E8402E",
  "#F27E18",
  "#F7C910",
  "#9ED031",
  "#34AF5A",
  "#389ADC",
  "#445CD5",
  "#9B59B6",
  "#999999",
  "#C13A2C",
  "#D35400",
  "#B99400",
  "#77A70D",
  "#007531",
  "#006492",
  "#00178C",
  "#670191",
  "#4D4D4D",
  "#660A00",
  "#803C00",
  "#745D00",
  "#466600",
  "#004C20",
  "#004667",
  "#001167",
  "#36014C",
  "#000000",
];

export const TablePartsType = {
  TwoBlockLeftSmall: "table.2_left_small",
  TwoBlock: "table.2",
  ThreeBlock: "table.3",
  FourBlock: "table.4",
} as const;

export type TablePartsType = typeof TablePartsType[keyof typeof TablePartsType];
